"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var typestyle_2 = require("typestyle");
exports.classes = typestyle_2.classes;
exports.keyframes = typestyle_2.keyframes;
function cssClass(name) {
    var styles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        styles[_i - 1] = arguments[_i];
    }
    return typestyle_1.style.apply(void 0, __spreadArrays(styles, [{
            $debugName: "datacatalog_" + name,
            $unique: true,
        }]));
}
exports.cssClass = cssClass;
//# sourceMappingURL=StyleFunctions.js.map